$(document).ready(function () {
    $(document).on('turbo:before-cache', function () {
        $('select.select2-hidden-accessible').select2('destroy');
    });

    $('.select2-simple').select2({
        width: '100%',
        minimumResultsForSearch: Infinity,
        allowClear: true,
        placeholder: ''
    });

    $('.select2-simple-search').select2({
        width: '100%',
        minimumResultsForSearch: 1,
        allowClear: true,
        placeholder: ''
    });

    $('.select2-multiple').select2({
        width: '100%',
        placeholder: ''
    });
});
